import { IconMapCar16, IconMapTrain16, IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import { RailwayItem } from 'shared/components/TransportAccessibility';
import { ETravelType, IRailway } from 'shared/types/houseInfo/railway';
import { getValue } from './getValue';

const TRAVEL_TYPE_ICON_MAP = {
  byFoot: IconMapWalk16,
  byCar: IconMapCar16,
};

export const renderRailways = (railways: IRailway[]) =>
  railways.map((item, index) => {
    const id = getValue(item.id, index);
    const travelType = getValue(item.travelType, ETravelType.ByCar);
    const travelTypeIcon = TRAVEL_TYPE_ICON_MAP[travelType];
    const travelTime = `${item.time} мин.`;

    return (
      <RailwayItem
        icon={IconMapTrain16}
        name={getValue(item.name, '')}
        travelTime={travelTime}
        travelTypeIcon={travelTypeIcon}
        key={`railway${id}`}
      />
    );
  });
